import React from "react";

export default class extends React.Component {

  render() {
    return (
      <section className="hyperloop section">
      <div className="container ending-container">
        <div className="row center-xs middle-xs">
          <div className="col-xs-12">
            <h1 className="heading">О проекте</h1>
            <h2 className="main-subheading">После изобретения колеса человек непрерывно совершенствовал механические средства передвижения, добиваясь увеличения скорости.    Ученые давно поняли, что необходимо максимально подавить силу трения.</h2>
            <div className='row start-xs'>
              <h2 style={{marginTop: '1em', marginBottom: '-1em'}} className="subheading">В данном проекте показаны основные этапы этого процесса: </h2>
              <ul className='fancy-list'>
                <li>сначала движение по дорожному полотну, </li>
                <li>затем переход на гладкие металлические рельсы, </li>
                <li>затем движение над рельсами на воздушной подушке, </li>
                <li>переход в воздушную среду, где сопротивление движению уменьшается с высотой,  </li>
                <li>и, наконец, транспорт будущего, где трасса должна проходить внутри трубы с откачанным воздухом, поэтому все силы сопротивления исключаются.</li>
              </ul>
              <h2 className="subheading">Описаны физические явления, сопровождающие данные процессы, по каждому типу движения есть страничка учебных материалов и окошки «ПОДУМАЙ».</h2>
            </div>
            </div>
          </div>
        </div>
      </section>
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/About.js